<template>
  <div class="demo-app">
    <WsConnectionBanner />
    <router-view />
    <!-- Progression des exports ZIP (arrière-plan, persiste à la navigation) -->
    <ZipExportProgress />
    <!-- <div class="map-wrapper">
      <GMap/>
    </div> -->
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, ref } from 'vue'
import { useMyStore } from './store'
import GMap from '/@/components/GMap.vue'
import WsConnectionBanner from '/@/components/common/WsConnectionBanner.vue'
import ZipExportProgress from '/@/components/common/ZipExportProgress.vue'

export default defineComponent({
  name: 'App',
  components: { GMap, WsConnectionBanner, ZipExportProgress },

  setup () {
    const store = useMyStore()
    return {}
  }
})
</script>
<style lang="scss" scoped>
.demo-app {
  width: 100%;
  height: 100%;

  .map-wrapper {
    height: 100%;
    width: 100%;
  }
}
</style>

<style lang="scss">
#demo-app {
  width: 100%;
  height: 100%
}
</style>
